const normalizeLegacyProjectUrl = url => {
    if (!url) {
        return url;
    }

    const allMatch = url.match(/^\/projects\/category\/all(?:\/([0-9]+))?\/?$/);

    if (allMatch) {
        return allMatch[1] ? `/projects/${allMatch[1]}/` : "/projects/";
    }

    const categoryMatch = url.match(/^\/projects\/category\/([^/]+)(?:\/([0-9]+))?\/?$/);

    if (categoryMatch) {
        return categoryMatch[2] ? `/projects/${categoryMatch[1]}/${categoryMatch[2]}/` : `/projects/${categoryMatch[1]}/`;
    }

    return url;
};

export default normalizeLegacyProjectUrl;
